const RAZORPAY_CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let razorpayPromise = null;

/**
 * Inject the Razorpay Checkout script once and resolve when it's ready.
 * Returns the global Razorpay constructor. Avoids loading it site-wide.
 */
export const loadRazorpay = () => {
  if (typeof window !== "undefined" && window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }

  if (razorpayPromise) {
    return razorpayPromise;
  }

  razorpayPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${RAZORPAY_CHECKOUT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Razorpay));
      existing.addEventListener("error", () => {
        razorpayPromise = null;
        reject(new Error("Failed to load Razorpay Checkout."));
      });
      if (window.Razorpay) resolve(window.Razorpay);
      return;
    }

    const script = document.createElement("script");
    script.src = RAZORPAY_CHECKOUT_SRC;
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) {
        resolve(window.Razorpay);
      } else {
        razorpayPromise = null;
        reject(new Error("Razorpay Checkout loaded but is unavailable."));
      }
    };
    script.onerror = () => {
      razorpayPromise = null;
      reject(new Error("Failed to load Razorpay Checkout."));
    };
    document.body.appendChild(script);
  });

  return razorpayPromise;
};

export default loadRazorpay;
